import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {BlogService} from "../../../shared/services/blog.service";
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit {
    blogs :any
    slug: any;
    selectedBlog: any;
    otherBlogs =[]

    constructor(private route: ActivatedRoute,
                private router: Router,
                private blogServices: BlogService,

    ) {
        this.blogs = this.blogServices.blogs
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            const slug = params.get('slug');
            if (slug) {
                this.selectedBlog = this.blogs.find(blog => blog.slug === slug);
                this.otherBlogs = this.blogs.filter(blog => blog.slug !== slug);
            }
        });
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }


}
